/* eslint-disable react/jsx-handler-names */

'use strict';
import forEach from 'lodash/forEach';
import includes from 'lodash/includes';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';
import noop from 'lodash/noop';
import React from 'react';
import ReactDOM from 'react-dom';
import {toast, ToastContainer} from 'react-toastify';
import DefaultCloseButton from 'react-toastify/lib/DefaultCloseButton';
import {ToastMessage} from './compnents/ToastMessage';


ToastService.$inject = [
  '$log',
  '$translate',
  'TOAST_TYPES',
];

export function ToastService(
  $log,
  $translate,
  TOAST_TYPES,
) {
  const availableTypes = ['info', 'success', 'error', 'warning'];
  const toastService = this;
  const handleClose = noop;

  toastService.init = init;
  toastService.TOAST_TYPES = TOAST_TYPES;
  toastService.isAvailableType = isAvailableType;
  toastService.isActive = isActive;
  toastService.showMessageSync = showMessage;
  toastService.showMessage = showMessageAsync;
  toastService.showI18nMessage = showI18nMessage;
  toastService.dismiss = dismiss;

  function init() {
    this.node = document.createElement('div');
    document.body.appendChild(this.node);

    ReactDOM.render((
      <ToastContainer
        className="ToastContainer"
        onClose={handleClose}
        autoClose={5000}
        hideProgressBar={true}
        pauseOnHover={true}
        position={toast.POSITION.BOTTOM_RIGHT}
      />
    ), this.node);
  }

  function isAvailableType(type) {
    if (!type) return false;
    return includes(availableTypes, type);
  }

  function isActive(id) {
    return toast.isActive(id);
  }

  function showMessage(message, title, type, options = {}) {
    if (!isAvailableType(type)) {
      $log.warn('Provided invalid type "' + type + '". Using default "info"');
      type = 'info';
    }

    let toastOptions;
    if (options.onCloseButton) {
      /* eslint-disable react/jsx-no-bind */
      const CloseButton = ({props, closeToast}) => (
        <DefaultCloseButton
          {...props}
          closeToast={props => (options.onCloseButton(props), closeToast(props))}
        />
      );
      toastOptions = {
        ...options.toastOptions,
        closeButton: <CloseButton />,
      };
      /* eslint-enable react/jsx-no-bind */
    } else {
      toastOptions = options.toastOptions;
    }

    // return the toastId
    return toast(({closeToast}) => (
      <ToastMessage
        closeToast={closeToast}
        title={title && !message ? null : title}
        message={title && !message ? title : message}
        type={type}
        action={options.action}
        onClick={options.onCloseButton}
      />
    ), {
      type,
      // autoClose: false,
      ...toastOptions,
    });
  }

  function showMessageAsync() {
    return Promise.resolve(showMessage.apply(this, arguments));
  }

  /**
   *
   * @param {object} options
   * @param {string} options.type - The type of the
   * @param {string} options.messageId  - The message translation id
   * @param {Object} [options.messageParams] - The message translation parameters. See angular translate documentation
   * @param {Object<String, String>} [options.i18nMessageParams] - Translation parameters that are themselves message codes to translate.
   * @param {string} [options.titleId] - The title translation id
   * @param {Object} [options.titleParams] - The title translation parameters. See angular translate documentation
   */
  function showI18nMessage(options) {
    if (!isObject(options)) {
      // eslint-disable-next-line max-len
      throw new Error('$toast.showI18nMessage expects an object with the properties: messageId, messageParams, titleId, titleParams, type');
    }
    let title = null;
    let message;

    if (isString(options.titleId)) {
      if (isObject(options.titleParams)) {
        title = $translate.instant(options.titleId, options.titleParams);
      } else {
        title = $translate.instant(options.titleId);
      }
    }

    if (isString(options.messageId)) {
      const messageParams = isObject(options.messageParams) ? options.messageParams : {};

      if (isObject(options.i18nMessageParams)) {
        forEach(options.i18nMessageParams, (code, prop) => messageParams[prop] = $translate.instant(code));
      }

      message = $translate.instant(options.messageId, messageParams);
    }

    const messageOptions = {
      action: options.action,
      toastOptions: options.toastOptions,
    };
    return toastService.showMessage(message, title, options.type, messageOptions);
  }

  function dismiss(id) {
    if (!isUndefined(id)) {
      toast.dismiss(id);
    } else {
      toast.dismiss();
    }
  }

  function generateTestToasts() {
    setTimeout(() => this.showMessage('test message', 'title', 'success'), 3000);
    setTimeout(() => this.showMessage(null, 'Downloaded file.test successfully', 'success', {
      action: {
        className: 'button button-small button-balanced',
        label: 'Open',
        handler: () => console.log('open the file'),
      },
    }), 5000);
    setTimeout(() => this.showMessage(null, 'Downloading file.test failed', 'error', {
      action: {
        className: 'button button-small button-assertive',
        label: 'Retry',
        handler: () => console.log('retry the upload'),
      },
    }), 7000);
    setTimeout(() => this.showMessage('generic info message to user', null, 'info'), 10000);
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/toast-messages/ToastService.js